<!-- =========================================================================================
  File Name: DashboardAnalytics.vue
  Description: Dashboard Analytics
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="dashboard-analytics">
    <div class="vx-row">
      <div class="vx-col w-full md:w-1/2 mb-base">
        <datepicker placeholder="Select Date" v-model="datefrom"></datepicker>
      </div>
      <div class="vx-col w-full md:w-1/2 mb-base">
        <datepicker placeholder="Select Date" v-model="dateto"></datepicker>
      </div>
    </div>
    <p v-if="reportLoading" role="status" class="mb-4">กำลังโหลดรายงาน...</p>
    <div v-if="reportError" role="alert" class="mb-4">
      {{ reportError }} <vs-button @click="retryReport" size="small">ลองอีกครั้ง</vs-button>
    </div>
    <div class="vx-row" v-if="!reportLoading && !reportError">
      <!-- CARD 2: SUBSCRIBERS GAINED -->
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <statistics-card-line icon="SmileIcon" :statistic="Number(krungsri.total)" :statisticTitle="`แจ้งฝาก (${krungsri.success}/${krungsri.all})`" :chartData="deposit30" color="success" type="area"></statistics-card-line>
      </div>

      <!-- CARD 3: ORDER RECIEVED -->
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <statistics-card-line icon="FrownIcon" :statistic="Number(withdraw.total)" :statisticTitle="`แจ้งถอน (${withdraw.success}/${withdraw.all})`" :chartData="withdraw30" color="danger" type="area"></statistics-card-line>
      </div>

      <!-- CARD 3: ORDER RECIEVED -->
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <statistics-card-line icon="DollarSignIcon" :statistic="Number(krungsri.total)-Number(withdraw.total)" :statisticTitle="`ยอดได้เสีย`" color="success" type="area"></statistics-card-line>
      </div>

      <!-- CARD 3: ORDER RECIEVED -->
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <statistics-card-line icon="DollarSignIcon" :statistic="getPercent()" :statisticTitle="`%รายได้`" color="success" type="area"></statistics-card-line>
      </div>

      <!-- CARD 3: ORDER RECIEVED -->
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <statistics-card-line icon="ShoppingBagIcon" :statistic="Number(deposit.bonus)" :statisticTitle="`Bonus (${deposit.bonustotal})`" :chartData="bonus30" color="warning" type="area"></statistics-card-line>
      </div>

      <!-- CARD 2: SUBSCRIBERS GAINED -->
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <statistics-card-line icon="UsersIcon" :statistic="`${usersactive.active}/${usersactive.total}`" statisticTitle="Active Users" :chartData="active30" color="primary" type="area"></statistics-card-line>
      </div>

      <!-- CARD: FIRST CREDIT NEW USER -->
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <statistics-card-line icon="UserPlusIcon" :statistic="Number(firstcreditNew.total)" :statisticTitle="`ฝากแรกยูสใหม่ (${firstcreditNew.count} คน)`" color="primary" type="area"></statistics-card-line>
      </div>

      <!-- CARD: FIRST CREDIT OLD USER -->
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <statistics-card-line icon="UserCheckIcon" :statistic="Number(firstcreditOld.total)" :statisticTitle="`ฝากแรกลูกค้าเก่า (${firstcreditOld.count} คน)`" color="warning" type="area"></statistics-card-line>
      </div>
    </div>
    <!-- <div class="vx-row">
            <div class="vx-col w-full md:w-1/2 mb-base">
                <vx-card title="รายการฝาก">
                    <template slot="actions">
                        <feather-icon icon="SettingsIcon" svgClasses="w-6 h-6 text-grey"></feather-icon>
                    </template>
                    <div slot="no-body" class="p-6 pb-0">
                        <div class="flex" v-if="revenueComparisonLine.analyticsData">
                            <div class="mr-6">
                                <p class="mb-1 font-semibold">เดือนปัจจุบัน</p>
                                <p class="text-3xl text-success"><sup class="text-base mr-1">$</sup>{{ revenueComparisonLine.analyticsData.thisMonth.toLocaleString() }}</p>
                            </div>
                            <div>
                                <p class="mb-1 font-semibold">เดือนก่อน</p>
                                <p class="text-3xl"><sup class="text-base mr-1">$</sup>{{ revenueComparisonLine.analyticsData.lastMonth.toLocaleString() }}</p>
                            </div>
                        </div>
                        <vue-apex-charts
                          type="line"
                          height="266"
                          :options="analyticsData.revenueComparisonLine.chartOptions"
                          :series="revenueComparisonLine.series" />
                    </div>
                </vx-card>
            </div>
            <div class="vx-col w-full md:w-1/2 mb-base">
                <vx-card title="รายการถอน">
                    <template slot="actions">
                        <feather-icon icon="SettingsIcon" svgClasses="w-6 h-6 text-grey"></feather-icon>
                    </template>
                    <div slot="no-body" class="p-6 pb-0">
                        <div class="flex" v-if="revenueComparisonLine2.analyticsData">
                            <div class="mr-6">
                                <p class="mb-1 font-semibold">เดือนปัจจุบัน</p>
                                <p class="text-3xl text-danger"><sup class="text-base mr-1">$</sup>{{ revenueComparisonLine2.analyticsData.thisMonth.toLocaleString() }}</p>
                            </div>
                            <div>
                                <p class="mb-1 font-semibold">เดือนก่อน</p>
                                <p class="text-3xl"><sup class="text-base mr-1">$</sup>{{ revenueComparisonLine2.analyticsData.lastMonth.toLocaleString() }}</p>
                            </div>
                        </div>
                        <vue-apex-charts
                          type="line"
                          height="266"
                          :options="analyticsData.revenueComparisonLine.chartOptions"
                          :series="revenueComparisonLine2.series" />
                    </div>
                </vx-card>
            </div>
    </div>
    <div class="vx-row">
            <div class="vx-col w-full md:w-1/2 mb-base">
                <vx-card title="สรุปภาพรวม">
                    <template slot="actions">
                        <feather-icon icon="SettingsIcon" svgClasses="w-6 h-6 text-grey"></feather-icon>
                    </template>
                    <div slot="no-body" class="p-6 pb-0">
                        <div class="flex" v-if="revenueComparisonLine3.analyticsData">
                            <div class="mr-6">
                                <p class="mb-1 font-semibold">เดือนปัจจุบัน</p>
                                <p class="text-3xl text-success"><sup class="text-base mr-1">$</sup>{{ revenueComparisonLine3.analyticsData.thisMonth.toLocaleString() }}</p>
                            </div>
                            <div>
                                <p class="mb-1 font-semibold">เดือนก่อน</p>
                                <p class="text-3xl"><sup class="text-base mr-1">$</sup>{{ revenueComparisonLine3.analyticsData.lastMonth.toLocaleString() }}</p>
                            </div>
                        </div>
                        <vue-apex-charts
                          type="line"
                          height="266"
                          :options="analyticsData.revenueComparisonLine.chartOptions"
                          :series="revenueComparisonLine3.series" />
                    </div>
                </vx-card>
            </div>
            <div class="vx-col w-full md:w-1/2 mb-base">
                <vx-card title="ความเคลื่อนไหวของสมาชิก">
                    <template slot="actions">
                        <feather-icon icon="SettingsIcon" svgClasses="w-6 h-6 text-grey"></feather-icon>
                    </template>
                    <div slot="no-body" class="p-6 pb-0">
                        <div class="flex" v-if="revenueComparisonLine4.analyticsData">
                            <div class="mr-6">
                                <p class="mb-1 font-semibold">เดือนปัจจุบัน</p>
                                <p class="text-3xl text-warning">{{ revenueComparisonLine4.analyticsData.thisMonth.toLocaleString() }}</p>
                            </div>
                            <div>
                                <p class="mb-1 font-semibold">เดือนก่อน</p>
                                <p class="text-3xl">{{ revenueComparisonLine4.analyticsData.lastMonth.toLocaleString() }}</p>
                            </div>
                        </div>
                        <vue-apex-charts
                          type="line"
                          height="266"
                          :options="analyticsData.revenueComparisonLine.chartOptions"
                          :series="revenueComparisonLine4.series" />
                    </div>
                </vx-card>
            </div>
    </div> -->
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import analyticsData from './ui-elements/card/analyticsData.js'
import ChangeTimeDurationDropdown from '@/components/ChangeTimeDurationDropdown.vue'
import VxTimeline from '@/components/timeline/VxTimeline'
import Datepicker from 'vuejs-datepicker';
import moment from "moment-timezone";
import { pickerDate, createRangeLoader } from '@/services/reportRange';
import 'firebase/database';
//import router from '@/router'
export default {
  data () {
    return {
      datefrom: pickerDate(),
      dateto: pickerDate(),
      reportLoading: true,
      reportError: '',
      checkpointReward: {},
      subscribersGained: {},
      ordersRecevied: {},
      salesBarSession: {},
      supportTracker: {},
      productsOrder: {},
      salesRadar: {},
      percent:30,
      timelineData: [
        {
          color: 'primary',
          icon: 'PlusIcon',
          title: 'Client Meeting',
          desc: 'Bonbon macaroon jelly beans gummi bears jelly lollipop apple',
          time: '25 mins Ago'
        },
        {
          color: 'warning',
          icon: 'MailIcon',
          title: 'Email Newsletter',
          desc: 'Cupcake gummi bears soufflé caramels candy',
          time: '15 Days Ago'
        },
        {
          color: 'danger',
          icon: 'UsersIcon',
          title: 'Plan Webinar',
          desc: 'Candy ice cream cake. Halvah gummi bears',
          time: '20 days ago'
        },
        {
          color: 'success',
          icon: 'LayoutIcon',
          title: 'Launch Website',
          desc: 'Candy ice cream cake. Halvah gummi bears Cupcake gummi bears soufflé caramels candy.',
          time: '25 days ago'
        },
        {
          color: 'primary',
          icon: 'TvIcon',
          title: 'Marketing',
          desc: 'Candy ice cream cake. Halvah gummi bears Cupcake gummi bears.',
          time: '28 days ago'
        }
      ],
      analyticsData,
      dispatchedOrders: []
    }
  },
  components: {
    VueApexCharts,
    StatisticsCardLine,
    ChangeTimeDurationDropdown,
    VxTimeline,
    Datepicker
  },
  watch: {
    datefrom () {
      this.calculate();
    },
    dateto () {
      this.calculate();
    },
  },
  computed: {
    usersactive (){
      return this.$store.state.dashboard.usersactive
    },
    deposit () {
      return this.$store.state.dashboard.deposit
    },
    krungsri () {
      return this.$store.state.dashboard.krungsri
    },
    withdraw() {
      return this.$store.state.dashboard.withdraw
    },
    deposit30() {
      return this.$store.state.dashboard.deposit30
    },
    withdraw30(){
      return this.$store.state.dashboard.withdraw30
    },
    active30(){
      return this.$store.state.dashboard.active30
    },
    bonus30(){
      return this.$store.state.dashboard.bonus30
    },
    activeUserInfo() {
      return this.$store.state.AppActiveUser
    },
    revenueComparisonLine() {
      return this.$store.state.dashboard.revenueComparisonLine
    },
    revenueComparisonLine2() {
      return this.$store.state.dashboard.revenueComparisonLine2
    },
    revenueComparisonLine3() {
      return this.$store.state.dashboard.revenueComparisonLine3
    },
    revenueComparisonLine4() {
      return this.$store.state.dashboard.revenueComparisonLine4
    },
    firstcreditNew() {
      return this.$store.state.dashboard.firstcreditNew
    },
    firstcreditOld() {
      return this.$store.state.dashboard.firstcreditOld
    },
  },
  methods:{
    getPercent(){
      if(this.krungsri.total>0 && this.withdraw.total>0 && this.percent){
        return (((this.krungsri.total-this.withdraw.total)*this.percent)/100).toFixed(0)
      }else return 0;
    },
    calculate(){
      if (this._reportLoader) this._reportLoader.schedule(this.datefrom, this.dateto);
    },
    retryReport(){ this._reportLoader.schedule(this.datefrom, this.dateto, true); },
    customFormatter(date) {
      return moment(date).format('MMMM Do YYYY, h:mm:ss a');
    }
  },
  created () {
    this._reportLoader = createRangeLoader({
      invalidate: () => this.$store.dispatch('dashboard/invalidateHistory'),
      loading: value => { this.reportLoading = value; },
      error: value => { this.reportError = value; },
      load: async range => {
        const result = await this.$store.dispatch('dashboard/getHistory', {startdate: range.start, enddate: range.end});
        if (result.applied) this.percent = result.percent;
      }
    });
    this.retryReport();
  },
  beforeDestroy () { this._reportLoader.stop(); }

}
</script>

<style lang="scss">
/*! rtl:begin:ignore */
#dashboard-analytics {
  .greet-user{
    position: relative;

    .decore-left{
      position: absolute;
      left:0;
      top: 0;
    }
    .decore-right{
      position: absolute;
      right:0;
      top: 0;
    }
  }

  @media(max-width: 576px) {
    .decore-left, .decore-right{
      width: 140px;
    }
  }
}
/*! rtl:end:ignore */
</style>
